export type TruncateDecimalOptions = {
  fractionDigits?: number;
};

const truncateDecimal = (value: number, options?: TruncateDecimalOptions): number => {
  const { fractionDigits = 2 } = options || {};

  if (fractionDigits === 0) {
    return Math.trunc(value);
  }

  const factor = 10 ** fractionDigits;
  return Math.trunc(value * factor) / factor;
};

export default truncateDecimal;
